
<div class="component-wrapper">
    <main>
        <div class="information-card">
            <div class="top">
                <div class="left-cell">
                    <header>
                        <h1 id="ausschreibungName">{{ ausschreibung.name }}</h1>
                    </header>
                    <button *ngIf="ausschreibung.unterlagenVorhanden" (click)="openUnterlagenDialog(ausschreibung.ausschreibungsNummer)" class="unterlagen-open-dialog d-flex py-2 px-0" translate>ausschreibung.unterlagen.open-dialog</button>
                    <div>
                        <kendo-label class="title" translate>{{'tender.status' | translate}}</kendo-label>
                        <span class="status-open" *ngIf="isOpen">{{ 'tender.status.open_until' | translate }}: {{ ausschreibung.dateTo | date: languageService.GetCurrentShortDateFormat()}}</span>
                        <span class="status-open" *ngIf="isPermanentOpen">{{ 'tender.status.open' | translate }}</span>
                        <span class="status-closed" *ngIf="!isNotYetOpen && isExpired && !isPermanentOpen" >{{'tender.status.closed' | translate}}</span>
                        <span class="status-closed" *ngIf="isNotYetOpen">{{'tender.status.notyetOpen' | translate}}: {{ ausschreibung.dateFrom | date: languageService.GetCurrentShortDateFormat()}}</span>
                    </div>
                </div>
                <div class="right-cell" *ngIf="isLogoVisible(ausschreibung)">
                    <img [src]="getLogo(ausschreibung)" aria-label="logo" alt="logo">
                </div>
            </div>
            <hr aria-hidden="true">
            <div class="bottom">
                <kendo-label class="title" >{{'tender.description'| translate}}</kendo-label>
                <p class="content" *ngIf="isProjektbeschreibungVisible" [trimRichtextAriaLabel]="getGoalDescriptionText(ausschreibung)" [innerHTMLBypassXSS]="getGoalDescriptionText(ausschreibung)"></p>
                <span class="content" *ngIf="isNoDescriptionMessageVisible">{{ 'tender.no_description_available' | translate}}</span>
            </div>
        </div>
    </main>
    <footer>
        <button kendoButton [disabled]="isCreateButtonDisabled" (click)="onCreateClick()" [attr.aria-label]="getButtonText()">{{'tender.apply' | translate }}</button>
    </footer>
</div>